// src/store/api/authApi.js
// ✅ Fix export conflictuel : getProfileCoach SUPPRIMÉ de ce fichier
//    Il est déjà dans profileApi.js — webpack error "conflicting star exports"
import { baseApi } from "./baseApi";

export const authApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({

    // POST /api/login
    login: builder.mutation({
      query: (credentials) => ({
        url: "/login",
        method: "POST",
        body: credentials,
      }),
    }),

    // POST /api/logout
    logout: builder.mutation({
      query: () => ({
        url: "/logout",
        method: "POST",
      }),
    }),

    // POST /api/forgot-password
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: "/forgot-password",
        method: "POST",
        body: data,
      }),
    }),

    // POST /api/register/stagiaire
    registerStagiaire: builder.mutation({
      query: (data) => ({
        url: "/register/stagiaire",
        method: "POST",
        body: data,
      }),
    }),

    // POST /api/register/coache
    registerCoache: builder.mutation({
      query: (data) => ({
        url: "/register/coache",
        method: "POST",
        body: data,
      }),
    }),

    // POST /api/sso/verify-and-login
    ssoVerifyAndLogin: builder.mutation({
      query: (data) => ({
        url: "/sso/verify-and-login",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useRegisterStagiaireMutation,
  useRegisterCoacheMutation,
  useSsoVerifyAndLoginMutation,
} = authApi;
